import { League, User } from '../../../../core/models';

/**
 * This is Comp Model Class
 */
export class CompModel extends League {
	get defaults() {
		return {
			...super.defaults,
			start_round: 1,
			type: 'open',
			template_type: 'overall',
			user_rank: '-'
		};
	}

	/**
	 * Return field for current league
	 * @returns object
	 */
	getFormData() {
		let all_data  = this.toJSON(),
			form_data = {
				name:        all_data.name,
				avatar:      all_data.avatar,
				privacy:     all_data.privacy,
				start_round: all_data.start_round,
				coaches_box: all_data.coaches_box
			};

		return form_data;
	}

	checkLeagueMember() {
		return true;
	}

	getCreateLeagueUrl(){
		return 'comps/create';
	}

	getUpdateLeagueUrl() {
		return 'comps/update';
	}

	/**
	 * Set url for getting one league
	 * @returns {CompModel}
	 */
	setShowUrl() {
		this.url = 'comps/league';
		return this;
	}

	/**
	 * Set url for getting one regenerate comp
	 * @returns {CompModel}
	 */
	setRegenerateShowUrl() {
		this.url = 'comps/regenerate_show';
		return this;
	}

	setInvitesUrl() {
		this.url = 'comps/invite_to_comp';
		return this;
	}

	setJoinUrl() {
		this.url = 'comps/join_to_comp';
		return this;
	}

	setInviteAllUrl() {
		this.url = 'comps/regenerate_invite';
		return this;
	}

	setLeaveUrl() {
		this.url = 'comps/remove_user';
		return this;
	}

	leave() {
		let data = {
			data: {
				comp_id: this.get( 'id' ),
				user_id: User.get( 'id' )
			},
			type: 'league:leave'
		};

		this.setLeaveUrl()
			.getData( data );

		return this;
	}

	setRemoveUrl() {
		this.url = 'comps/remove';
		return this;
	}
}

export default CompModel;